<script>
import api from '@/helpers/api'
import isEmpty from 'lodash/isEmpty'
export default {
  name: 'product.specs',
  props: {
    product_id: { type: String, required: true }
  },
  data: () => ({
    showForm: false,
    isLoading: false,
    selected: {},
    product: {},
    fields: [
      {
        key: 'key',
        label: 'Name',
        thStyle: { width: '200px' },
        class: ' align-middle'
      },
      {
        key: 'formattedValue',
        label: 'Value',
        class: ' align-middle'
      },
      {
        key: 'actions',
        label: '',
        sortable: false,
        thStyle: { width: '100px' },
        class: 'text-right align-middle'
      }
    ]
  }),
  computed: {
    productSpecification () {
      if (isEmpty(this.product)) return []
      return Object.keys(this.product.specifications).map(key => ({
        key,
        value: this.product.specifications[key],
        name: this.t(`attribute.${key}.key`, { defaultString: key }),
        formattedValue: this.t(
          this.t(`attribute.${key}.value`, {
            value: this.product.specifications[key],
            defaultString: this.product.specifications[key]
          })
        )
      }))
    }
  },
  mounted () {
    this.onInit()
  },
  watch: {
    product_id: { handler: 'onInit', immediate: true }
  },
  methods: {
    t (str, options = {}) {
      const { defaultString } = options

      if (!defaultString) return this.$t(str, { ...options })

      // use `$te` and `$t
      return this.$t && this.$te
        ? this.$te(str)
          ? this.$t(str, { ...options })
          : defaultString
        : defaultString
        ? defaultString
        : str
    },
    onNewSpec () {
      this.selected = {}
      this.showForm = true
    },
    onSpecCreatedHandler (spec) {
      this.product.specifications[spec.key] = spec.value
      this.product = {
        ...this.product,
        specifications: { ...this.product.specifications }
      }

      this.onSave()
    },

    onEditSpec (item) {
      this.selected = { ...item }
      this.showForm = true
    },

    onRemoveSpec (item) {
      delete this.product.specifications[item.key]
      this.product = {
        ...this.product,
        specifications: { ...this.product.specifications }
      }

      this.onSave()
    },
    async onInit () {
      this.isLoading = true
      let item = await api.items.fetch({
        id: this.product_id
      })
      this.product = {
        ...item
      }
      this.isLoading = false
    },
    async onSave () {
      let valid = true

      if (valid) {
        const data = {
          ...this.product
        }

        try {
          this.isLoading = true
          let item = await api.items.update({
            ...data,
            id: this.product_id
          })
          this.$bvToast.toast(`Product info was saved!`, {
            title: 'Changes Saved',
            solid: true,
            toaster: 'b-toaster-top-center',
            variant: 'success',
            autoHideDelay: 1000,
            appendToast: true
          })
          this.isLoading = false
        } catch (error) {
          this.isLoading = false

          this.$bvToast.toast(`${error}!`, {
            title: 'Error',
            solid: true,
            toaster: 'b-toaster-top-center',
            variant: 'danger',
            autoHideDelay: 1000,
            appendToast: true
          })
        }
      }
    }
  }
}
</script>
<template>
  <g-overlay :show="isLoading">
    <b-card>
      <div class="mb-4 d-flex justify-content-between align-items-center">
        <h4 class="card-title">Specifications</h4>
        <b-btn class="btn-label" variant="primary" v-on:click="onNewSpec">
          <i class="bx bx-plus label-icon"></i>New Spec
        </b-btn>
      </div>

      <b-table
        :show-empty="true"
        hover
        :items="productSpecification"
        :fields="fields"
        :busy="isLoading"
        head-variant="primary"
        thead-tr-class="border-bottom bg-light"
        tbody-tr-class="border-bottom "
        borderless
        small
      >
        <template v-slot:cell(key)="row">
          {{ row.item.name }}
        </template>
        <template v-slot:cell(actions)="row">
          <div class="d-flex align-items-center m-0 p-0">
            <b-button
              variant="link"
              size="sm"
              class="align-self-center mr-1 p-2"
              v-on:click="onEditSpec(row.item)"
            >
              <i class="far fa-edit"></i>
            </b-button>
            <b-button
              variant="link"
              size="sm"
              class="align-self-center p-2"
              v-on:click="onRemoveSpec(row.item)"
            >
              <i class="fas fa-trash-alt text-danger"></i>
            </b-button>
          </div>
        </template>
      </b-table>
    </b-card>
    <app-attribute-value-form-dialog
      :visible.sync="showForm"
      :attribute="selected"
      ref="attribute-form"
      v-on:created="onSpecCreatedHandler"
    />
  </g-overlay>
</template>
